class EventStatus {
	static PendingNotPlayed = -4;
	static PendingPlayed = -3;
	static Invalid = 0;
	static Ready = 1;
	static Current = 2;
	static Played = 3;
	static NotPlayed = 4;
	static EventError = 5;
	static Paused = 6;
}

export default EventStatus;